import { ErrorHandler, inject, Injectable } from '@angular/core';
import { DefaultTitleStrategy, RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * This title strategy validates that developers have set a title for routes
 * by showing an error if a route has no title configured. Apart from that it behaves
 * like the default title strategy.
 */
@Injectable()
export class TitleValidatingAppTitleStrategy extends TitleStrategy {
  private readonly errorHandler = inject(ErrorHandler);
  private readonly defaultTitleStrategy = inject(DefaultTitleStrategy);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const currentRouteTitle = this.buildTitle(snapshot);
    if (!currentRouteTitle) {
      const path = snapshot.root.pathFromRoot.map(r => r.url.join('/')).filter(s => s)
        .join('/');

      // Pass directly to error handler to ensure the router's pipeline does not suppress it
      // (which makes it appear in the console log only, but we want it to be in-the-face of developers at least,
      // in case we forget to set the title for a route).
      this.errorHandler.handleError(new Error(`Route has no title configured: "${path}"`));
      return;
    }

    this.defaultTitleStrategy.updateTitle(snapshot);
  }
}
